import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import { BIG_WHALE, TRAVEL_PACKAGES } from '../../routes/routes';
import { changeUserInfo } from '../../slices/auth-slice';
import {
  checkSideModalAsync,
  getDashboardAsync,
  getJoinedAfterUsersAsync,
  getLastRegisteredUsersAsync,
  updatePackageRankNotificationAsync
} from './Dashboard.requests';

export const getDashboardInfo = createAsyncThunk(
  'auth/getDashboardInfo',
  async () => {
    const dashboardInfo = await getDashboardAsync();
    const lastRegisteredUsers = await getLastRegisteredUsersAsync();
    const joinedAfterCount = await getJoinedAfterUsersAsync();

    return {
      dashboardInfo,
      lastRegisteredUsers,
      joinedAfterCount
    };
  }
);

export const updatePackageRankNotification = createAsyncThunk(
  'auth/updatePackageRankNotification',
  async (id: number) => {
    await updatePackageRankNotificationAsync(id);
    return id;
  }
);

export const checkSideModal = createAsyncThunk(
  'auth/checkSideModal',
  async (
    history: {
      push(url: string): void;
    },
    { getState, dispatch }
  ) => {
    await checkSideModalAsync();

    const state = getState() as RootState;

    const user = { ...state.auth.userInfo, isSideModalChecked: true };

    dispatch(changeUserInfo(user));

    setUserToLS(user);

    history.push(TRAVEL_PACKAGES);
  }
);
